import { useRef, useCallback, Dispatch, SetStateAction } from "react";
import { PaginationType } from "@finbackoffice/site-core";

export const useLazyLoad = (
    loading: boolean,
    setPagination: Dispatch<SetStateAction<PaginationType>>,
    hasMore: boolean,
) => {
    const observer = useRef<IntersectionObserver | null>(null);
    const endRef = useCallback(
        (node: HTMLDivElement) => {
            if (loading) return;
            if (observer.current) (observer.current as any).disconnect();
            observer.current = new IntersectionObserver((entries) => {
                if (entries[0].isIntersecting && hasMore) {
                    setPagination((state: PaginationType) => ({
                        ...state,
                        page: state.page + 1,
                    }));
                }
            });
            if (node) observer.current.observe(node);
        },
        [loading, hasMore, setPagination],
    );

    return { endRef };
};
